module.exports = __webpack_public_path__ + "static/media/19.e7addfe4.jpg";